import React from 'react';

const UserRegistered = props => {
    return (
        <div className="column is-6 is-offset-1 content overflow-scroll">
            <h1 className="title">Registrierung fast fertig</h1>
            <p>
                Ihre Registrierung ist fast abgeschlossen; die Bestätigungs-E-Mail wird jeden Moment in Ihrem Postfach
                eintreffen. Zum Abschließen der Registrierung klicken Sie bitte auf den darin enthaltenen Link.
            </p>
        </div>
    );
};
export default UserRegistered;



/** WEBPACK FOOTER **
 ** ./src/components/UserRegistered.jsx
 **/